import { render, staticRenderFns } from "./LabelAndElement.vue?vue&type=template&id=a266e5a8"
import script from "./LabelAndElement.vue?vue&type=script&lang=js"
export * from "./LabelAndElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports